import Vue from 'vue';
import HTTPService from '@/services/httpService';
import router from '@/router';
import VueAppInsights from 'vue-application-insights';

export default async function initializeApplication(): Promise<number> {
  const result = await new HTTPService().httpInstance.get('config.json');

  window.$config = result.data;

  Vue.use(VueAppInsights, {
    id: result.data.ApplicationInsights.InstrumentationKey,
    router,
    trackInitialPageView: true,
    onAfterScriptLoaded: (data: any) => {
      data.addTelemetryInitializer(
        (envelope: any) => {
          envelope.data.applicationName = result.data.ApplicationInsights.ApplicationName;
          if (typeof (envelope.baseData) === 'string') {
            const name = envelope.baseData;
            envelope.baseData = {};
            envelope.baseData.name = name;
          }
        },
      );
    },
  });

  return Promise.resolve(1);
}
